import { BaseService } from './BaseService';
import fetchShipmentQuery from '@/graphql/queries/FetchShipment.gql';
import updateShipmentQuery from '@/graphql/mutations/ShipmentUpdate.gql';
import lockShipment from '@/graphql/mutations/LockShipment.gql';
import deleteShipment from '@/graphql/mutations/ShipmentDelete.gql';
import { ApolloQueryResult } from 'apollo-client';
import { FetchResult } from 'apollo-link';
import store from '@/stores/index';
import {
  fetchShipment,
  ShipmentUpdateInput,
  ShipmentLockInput,
  ShipmentStatusEnum
} from '@/types/graphql/schemaTypes';

class ShipmentService extends BaseService {
  public fetchShipment(shipmentId: string): Promise<ApolloQueryResult<fetchShipment>> {
    return this.client.query({
      query: fetchShipmentQuery,
      variables: {
        shipmentArgs: {
          shipmentId
        }
      }
    });
  }

  public updateShipment(shipmentUpdateArgs: ShipmentUpdateInput):
  Promise<FetchResult<ShipmentUpdateInput>> {
    return this.client.mutate({
      mutation: updateShipmentQuery,
      variables: {
        shipmentUpdateArgs
      }
    }).catch((error) => {
      store.commit('Alert/addAlert', { type: 'error', message: error.message });
      return error;
    });
  }

  public lock(shipmentLockArgs: ShipmentLockInput) {
    return this.client.mutate({
      mutation: lockShipment,
      variables: {
        arguments: shipmentLockArgs
      }
    });
  }

  public deleteShipment(shipmentId: string): Promise<FetchResult<boolean>> {
    return this.client.mutate({
      mutation: deleteShipment,
      variables: {
        shipmentId
      }
    });
  }

  public unarchiveShipment(shipmentId: string):
  Promise<FetchResult<ShipmentUpdateInput>> {
    return this.client.mutate({
      mutation: updateShipmentQuery,
      variables: {
        shipmentUpdateArgs: {
          id: shipmentId,
          status: ShipmentStatusEnum.shipment_preparing
        }
      }
    }).catch((error) => {
      store.commit('Alert/addAlert', { type: 'error', message: error.message });
      return error;
    });
  }
}

export const shipmentService = new ShipmentService();
